export default {
  setData (state, payload) {
    if (!payload) {
      return
    }

    state.data = payload
  },
  clearState (state) {
    console.log('-=-= category')
    state.data = []
  }
}